/**
 * ProductGroupMember - one variation of a group.
 *
 * The member is a real product with its own SKU, barcode, price, stock and gallery; the
 * group only records which attribute values it represents.
 */
export class ProductGroupMember {
  constructor(data = {}) {
    this.id = data.id || null;
    this.productId = data.productId || null;
    this.productName = data.productName || null;
    this.productSku = data.productSku || null;
    this.productSlug = data.productSlug || null;
    this.priceWithVat = data.priceWithVat !== undefined && data.priceWithVat !== null
      ? Number(data.priceWithVat)
      : null;
    this.stockQuantity = data.stockQuantity !== undefined && data.stockQuantity !== null
      ? Number(data.stockQuantity)
      : 0;
    this.inStock = data.inStock !== undefined ? Boolean(data.inStock) : this.stockQuantity > 0;
    this.isActive = data.isActive !== undefined ? Boolean(data.isActive) : true;
    this.position = data.position !== undefined && data.position !== null ? data.position : 0;
    this.attributeValues = { ...(data.attributeValues || {}) };
  }

  static fromJSON(json) {
    if (!json) {
      return null;
    }

    return new ProductGroupMember({
      id: json.id,
      productId: json.productId,
      productName: json.productName,
      productSku: json.productSku,
      productSlug: json.productSlug,
      priceWithVat: json.priceWithVat,
      stockQuantity: json.stockQuantity,
      inStock: json.inStock,
      isActive: json.isActive,
      position: json.position,
      attributeValues: json.attributeValues,
    });
  }

  toJSON() {
    return {
      id: this.id,
      productId: this.productId,
      position: this.position,
      attributeValues: { ...this.attributeValues },
    };
  }
}
